import { send } from '../../../../../src/network/network';

// This is a best guess from the API response
// all the "null" fields are definitely wrong
export interface SignupResponse {
  credit: number;
  day_of_week: number;
  did_checkout: boolean;
  email: string;
  first_name: string;
  id: number;
  is_on_hold: null;
  is_on_hold_next_week: null;
  is_vip: boolean;
  last_name: string;
  life_promo: null;
  next_delivery_after_hold: null;
  on_hold_until_date: null;
  plan: null;
  rollover_credit_expiration: null;
  rollover_credits: number;
}

export interface SignupParams {
  email: string;
  password: string;
  first_name?: string;
  last_name?: string;
  captcha_token?: string;
  /**
   * Marks a freemium (guest-flow) signup. The backend creates the customer
   * with `CustomerStatus.GUEST` instead of `PRE_CHECKOUT`. Omit, rather than
   * send `false`, for a standard signup.
   */
  is_guest_flow?: true;
}

export async function postApiV2AuthSignup(params: SignupParams) {
  return await send<SignupResponse>({
    path: '/api/v2/auth/signup/',
    method: 'POST',
    body: params,
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  });
}
